/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AidModelArchiveStateRequest,
  AidModelCopyRequest,
  AidModelDto,
  AidModelRenameRequest,
  AidModelRequest,
  AidModelUpdateRequest,
  GetAidModelsParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';
import { customAxiosResponse } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns aid model details by ID
 * @summary Get aid model by ID
 */
export const getAidModelById = (
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAidModelByIdQueryKey = (
  oktaUserId: string,
  clientId: number,
  id: number
) => {
  return [`/api/${oktaUserId}/clients/${clientId}/aid-models/${id}`] as const;
};

export const getGetAidModelByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAidModelById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAidModelByIdQueryKey(oktaUserId, clientId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAidModelById>>> = ({
    signal,
  }) => getAidModelById(oktaUserId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAidModelById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAidModelByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAidModelById>>
>;
export type GetAidModelByIdQueryError = ErrorType<unknown>;

export function useGetAidModelById<
  TData = Awaited<ReturnType<typeof getAidModelById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelById>>,
          TError,
          Awaited<ReturnType<typeof getAidModelById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelById<
  TData = Awaited<ReturnType<typeof getAidModelById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelById>>,
          TError,
          Awaited<ReturnType<typeof getAidModelById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelById<
  TData = Awaited<ReturnType<typeof getAidModelById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get aid model by ID
 */

export function useGetAidModelById<
  TData = Awaited<ReturnType<typeof getAidModelById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAidModelByIdQueryOptions(
    oktaUserId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates the Basic Information (name, description, entry term, enrollment type) of an aid model
 * @summary Update aid model
 */
export const updateAidModel = (
  oktaUserId: string,
  clientId: number,
  id: number,
  aidModelUpdateRequest: BodyType<AidModelUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateAidModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAidModel>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAidModel>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateAidModel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAidModel>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelUpdateRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return updateAidModel(oktaUserId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAidModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAidModel>>
>;
export type UpdateAidModelMutationBody = BodyType<AidModelUpdateRequest>;
export type UpdateAidModelMutationError = ErrorType<unknown>;

/**
 * @summary Update aid model
 */
export const useUpdateAidModel = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAidModel>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<AidModelUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAidModel>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelUpdateRequest>;
  },
  TContext
> => {
  return useMutation(getUpdateAidModelMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates only the name of an aid model
 * @summary Rename aid model
 */
export const renameAidModel = (
  oktaUserId: string,
  clientId: number,
  id: number,
  aidModelRenameRequest: BodyType<AidModelRenameRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelRenameRequest,
      signal,
    },
    options
  );
};

export const getRenameAidModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameAidModel>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelRenameRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameAidModel>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelRenameRequest>;
  },
  TContext
> => {
  const mutationKey = ['renameAidModel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameAidModel>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelRenameRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return renameAidModel(oktaUserId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameAidModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameAidModel>>
>;
export type RenameAidModelMutationBody = BodyType<AidModelRenameRequest>;
export type RenameAidModelMutationError = ErrorType<unknown>;

/**
 * @summary Rename aid model
 */
export const useRenameAidModel = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameAidModel>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<AidModelRenameRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof renameAidModel>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelRenameRequest>;
  },
  TContext
> => {
  return useMutation(getRenameAidModelMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns a paginated list of aid models with optional filtering and sorting
 * @summary Get all aid models
 */
export const getAidModels = (
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams,
  options?: SecondParameter<typeof customAxiosResponse>,
  signal?: AbortSignal
) => {
  return customAxiosResponse<AidModelDto[]>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetAidModelsQueryKey = (
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/aid-models`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAidModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAidModels>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAidModelsQueryKey(oktaUserId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAidModels>>> = ({
    signal,
  }) => getAidModels(oktaUserId, clientId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAidModels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAidModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAidModels>>
>;
export type GetAidModelsQueryError = ErrorType<unknown>;

export function useGetAidModels<
  TData = Awaited<ReturnType<typeof getAidModels>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: undefined | GetAidModelsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModels>>,
          TError,
          Awaited<ReturnType<typeof getAidModels>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModels<
  TData = Awaited<ReturnType<typeof getAidModels>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModels>>,
          TError,
          Awaited<ReturnType<typeof getAidModels>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModels<
  TData = Awaited<ReturnType<typeof getAidModels>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all aid models
 */

export function useGetAidModels<
  TData = Awaited<ReturnType<typeof getAidModels>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetAidModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAidModelsQueryOptions(
    oktaUserId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />Creates a new aid model
 * @summary Create aid model
 */
export const createAidModel = (
  oktaUserId: string,
  clientId: number,
  aidModelRequest: BodyType<AidModelRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelRequest,
      signal,
    },
    options
  );
};

export const getCreateAidModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAidModel>>,
    TError,
    { oktaUserId: string; clientId: number; data: BodyType<AidModelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAidModel>>,
  TError,
  { oktaUserId: string; clientId: number; data: BodyType<AidModelRequest> },
  TContext
> => {
  const mutationKey = ['createAidModel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAidModel>>,
    { oktaUserId: string; clientId: number; data: BodyType<AidModelRequest> }
  > = (props) => {
    const { oktaUserId, clientId, data } = props ?? {};

    return createAidModel(oktaUserId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAidModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAidModel>>
>;
export type CreateAidModelMutationBody = BodyType<AidModelRequest>;
export type CreateAidModelMutationError = ErrorType<unknown>;

/**
 * @summary Create aid model
 */
export const useCreateAidModel = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAidModel>>,
      TError,
      { oktaUserId: string; clientId: number; data: BodyType<AidModelRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAidModel>>,
  TError,
  { oktaUserId: string; clientId: number; data: BodyType<AidModelRequest> },
  TContext
> => {
  return useMutation(getCreateAidModelMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Creates a new aid model as a deep copy of an existing one, owned by the caller
 * @summary Copy aid model
 */
export const createAidModelCopy = (
  oktaUserId: string,
  clientId: number,
  id: number,
  aidModelCopyRequest: BodyType<AidModelCopyRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models/${id}/copies`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelCopyRequest,
      signal,
    },
    options
  );
};

export const getCreateAidModelCopyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAidModelCopy>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelCopyRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAidModelCopy>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelCopyRequest>;
  },
  TContext
> => {
  const mutationKey = ['createAidModelCopy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAidModelCopy>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelCopyRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return createAidModelCopy(oktaUserId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAidModelCopyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAidModelCopy>>
>;
export type CreateAidModelCopyMutationBody = BodyType<AidModelCopyRequest>;
export type CreateAidModelCopyMutationError = ErrorType<unknown>;

/**
 * @summary Copy aid model
 */
export const useCreateAidModelCopy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAidModelCopy>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<AidModelCopyRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAidModelCopy>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelCopyRequest>;
  },
  TContext
> => {
  return useMutation(
    getCreateAidModelCopyMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates the archived state of an aid model; the caller must be the owner or an administrator
 * @summary Archive or restore aid model
 */
export const updateAidModelArchiveState = (
  oktaUserId: string,
  clientId: number,
  id: number,
  aidModelArchiveStateRequest: BodyType<AidModelArchiveStateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelDto>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/aid-models/${id}/archive-state`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelArchiveStateRequest,
      signal,
    },
    options
  );
};

export const getUpdateAidModelArchiveStateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAidModelArchiveState>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelArchiveStateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAidModelArchiveState>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelArchiveStateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateAidModelArchiveState'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAidModelArchiveState>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<AidModelArchiveStateRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return updateAidModelArchiveState(
      oktaUserId,
      clientId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAidModelArchiveStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAidModelArchiveState>>
>;
export type UpdateAidModelArchiveStateMutationBody =
  BodyType<AidModelArchiveStateRequest>;
export type UpdateAidModelArchiveStateMutationError = ErrorType<unknown>;

/**
 * @summary Archive or restore aid model
 */
export const useUpdateAidModelArchiveState = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAidModelArchiveState>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<AidModelArchiveStateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAidModelArchiveState>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<AidModelArchiveStateRequest>;
  },
  TContext
> => {
  return useMutation(
    getUpdateAidModelArchiveStateMutationOptions(options),
    queryClient
  );
};
